import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { AvatarWithFilterFragment } from "@shared/data/fragments/AvatarFragment/AvatarWithFilterFragment.fragment";
import { AVATAR_FRAGMENT_WITH_FILTER } from "@shared/data/fragments/AvatarFragment/AvatarWithFilterFragment.fragment";
import type { AvatarErrorsType } from "@shared/types/CreateAvatarErrorTypes.d";
import { AvatarSize } from "@shared/types/avatarSize";

const UserAvatarCreate_Shared_Mutation = gql`
  mutation UserAvatarCreate_Shared_Mutation(
    $input: UserAvatarCreateInput!
    $filter: PhotoSizeFilters!
  ) {
    userAvatarCreate(input: $input) {
      avatar {
        ...AvatarWithFilterFragment
      }
      errors {
        message
        fields {
          photo
        }
      }
    }
  }
  ${AVATAR_FRAGMENT_WITH_FILTER}
`;

interface UserAvatarCreateData {
  userAvatarCreate: {
    avatar: AvatarWithFilterFragment;
    errors: AvatarErrorsType;
  };
}

interface Variables {
  input?: {
    attributes: {
      photo: File;
    };
  };
  filter?: AvatarSize;
}

const useUserAvatarCreateMutation = (
  options: MutationHookOptions<UserAvatarCreateData, Variables> = {
    variables: {
      filter: AvatarSize.LARGE,
    },
  }
) => useMutation<UserAvatarCreateData, Variables>(UserAvatarCreate_Shared_Mutation, options);

export type { UserAvatarCreateData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useUserAvatarCreateMutation, UserAvatarCreate_Shared_Mutation };
